import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    height: 20vh;
    background: #0D6786;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: Column;

    h4{
        text-align: center;
        margin-bottom: 40px;
        text-transform: uppercase;
        color: #fff;
        word-spacing: 4px;
    }

    .wrapper{
        display: flex;
        justify-content: center;
        align-items: center;

        .icone{
            cursor: pointer;
            font-size: 1.8rem;
            margin: 0 20px;
            color: #fff;

            &:hover{
                transform: scale(1.4);
                color: #ebc700;
            }
    }
    }

`